import { Component, Input, HostListener, Inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { IAppState } from '../../app.state';
import { toggleFullscreen, turnOffFullscreen } from '../../visual/visual.actions';
import { Config } from '../../universal-config';
import { ShareCopyService } from '../../share';
import { Router } from '@angular/router';
import { ShareConfigPopupComponent } from '../share-config-popup.component';
import { closeDialog, openDialog } from '../../common/dialogs/dialogs.actions';
import { SocialService } from '../../social/social.service';
import { GetNimbusPopupService } from "../../header/get-nimbus-popup.service";
import { isB2BOrgPredicate } from '../../../model/organization.model';

@Component({
  selector: 'nns-top',
  styles: [`
    :host{
      position:relative;
      min-width:320px;
      height:80px;
      width:100%;
    }
    :host.nns-top-folders{
      z-index: 2;
    }

    .nns-top-main {
      position:absolute;
      left:0;
      top:0;
      width:100%;
    }
    .nns-top-main .nns-wrapper {
      max-width:970px;
      min-width:320px;
      margin:0 auto;
      padding:0 10px;
      box-sizing:border-box;
      height:80px;
    }

    /*fullscreen*/
    :host.nns-fullscreen {
      position:absolute;
      left:0;
      top:-100%;
    }

    .nns-print-action :ng-deep nns-icon{
      min-width: 16px;
      min-height: 16px;
    }

    /*top fixed*/
    :host.nns-top-fixed {
      z-index:150;
      left:0;
      top:0;
    }
    :host.nns-top-fixed .nns-wrapper {
      -webkit-justify-content: flex-start;
      -ms-flex-pack: start;
      justify-content: flex-start;

      -webkit-align-items: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-align-content: center;
      -ms-flex-line-pack: center;
      align-content: center;

      height:60px;
      padding: 0 5px;
    }
    :host.nns-top-fixed .nns-save-to-nimbus {display:block; position: unset;}
    :host.nns-top-fixed .nns-top-actions {position: relative;}
    :host.nns-top-fixed .nns-top-title {display:none;}
    :host.nns-top-fixed .nns-top-main {
      position:fixed;
      background:#fff;
      border-bottom:1px solid #e2e2e2;
      box-shadow:0 4px 2px -2px rgba(0, 0, 0, 0.1);
    }

    :host.nns-fullscreen .nns-top-main {
      -ms-transform:translate(0, -100%);
      transform:translate(0, -100%);
    }
    :host.nns-fullscreen .nns-wrapper {
      max-width: 100%;
    }

    :host.nns-top-empty{
      height: 20px;
    }

    :host.nns-top-empty.nns-top-fixed{
        display: block;
    }
    @media only screen and (max-width: 1430px) and (min-width: 1200px) {
      :host.nns-top-align-left .nns-top-main{
        padding-right: 230px;
      }
    }

    @media only screen and (max-width: 1000px) {
      .nns-top-main .nns-wrapper {
        padding: 0 20px;
      }
    }

    @media only screen and (max-width: 768px) {
      .nns-top-content{
        flex-direction: column;
        align-items: flex-start;
      }
      :host.nns-top-empty{
        height: 20px;
      }
      .nns-wrapper {
        padding-left: 20px;
        padding-right: 20px;
      }
    }
  `, `
    :host-context(.nns-theme-night) .nns-top-main {
      border-bottom: 0px solid #2F3737;
    }
    :host-context(.nns-theme-night).nns-top-fixed .nns-top-main {
      background: #292E32;
      border-bottom: 1px solid #3B3B3B;
    }
    :host-context(.nns-fullwidth) .nns-wrapper {
      max-width: 100%;
      padding-left: 40px;
      padding-right: 40px;
    }


    @media only screen and (max-width: 768px) {
      :host-context(:not(.nns-embed)) :host {
        display: none;
      }
      :host-context(.nns-fullwidth) .nns-wrapper {
        padding-left: 20px;
        padding-right: 20px;
      }
    }
  `],
  template: `
    <div class="nns-top-main" flex>
      <div class="nns-wrapper" flex layout="row" layout-align="start center">

        <div class="nns-top-content" flex layout="row" layout-align="start center">
          <nns-breadcumbs flex="nogrow"[note]="note" [share]="share" [visual]="visual"></nns-breadcumbs>
          <nns-date
            *ngIf="branding && branding.sharesShowDate && note.type != 'folder'"
            [note]="note"
          ></nns-date>
        </div>

        <div class="nns-top-actions" flex="nogrow" *ngIf="printButton">
          <div class="nns-top-actions-layout" flex layout="row" layout-align="start center">
             <nns-top-action
              class="nns-print-action"
              [icon]="printButton.icon"
              [title]="printButton.title"
              (onClick)="printButton.handler()"
            ></nns-top-action>
          </div>
        </div>

        <div class="nns-top-actions" flex="nogrow" *ngIf="!visual.isEmbed">
          <div class="nns-top-actions-layout" flex layout="row" layout-align="start center">
            <nns-save-action
              *ngIf="false"
              class="nns-save-to-nimbus"
              [login]="login"
              [state]="getSaveState()"
              [shareCopy]="shareCopy"
              [showTitle]="true"
              [visual]="visual"
            ></nns-save-action>
            <nns-top-action
              *ngIf="!visual.isFullscreen && showShareConfigBtn"
              icon="manage"
              title="Manage"
              (onClick)="openConfigDialog()"
            ></nns-top-action>
            <nns-top-action
              *ngIf="!visual.isFullscreen && isShowFullscreenButton && branding.sharesFullscreen"
              icon="expand-inv"
              title="Full screen"
              (onClick)="toggleFullscreen(event)"
            ></nns-top-action>
            <nns-top-action
              *ngIf="visual.isFullscreen && isShowFullscreenButton"
              icon="collapse-dark"
              title="Close full screen"
              (click)="toggleFullscreen"
              (onClick)="toggleFullscreen(event)"
            ></nns-top-action>
            <nns-top-action
              clickOutside
              *ngIf="branding.sharesShareButton"
              icon="share-inv"
              title="Share"
              class="nns-toggle-share"
              showShareDropdown="true"
              [note]="note"
              [shareUrl]="shareUrl"
              [share]="share"
            ></nns-top-action>
          </div>
        </div>
      </div>
    </div>
  `
})
export class TopComponent {
  @Input() attachments;
  @Input() note;
  @Input() login;
  @Input() share;
  @Input() shareCopy;
  @Input() visual;
  @Input() branding;
  @Input() profile;

  isShowFullscreenButton = false;
  isB2B: boolean;
  shareUrl: string;
  showShareConfigBtn;

  printButton: {
    title: string;
    icon: string;
    handler: () => void;
  }

  constructor(
    public _store: Store<IAppState>,
    public _config: Config,
    public _shareCopyService: ShareCopyService,
    @Inject('isBrowser') public isBrowser: boolean,
    private _router: Router,
    public _socialService: SocialService,
    private _getNimbusPopupService: GetNimbusPopupService
  ) {
  }

  toggleFullscreen() {
    if(!this.visual.isFullscreen) {
      this._router.navigate([], {queryParams: {isFullscreen: 'true'}});
    }
    this._store.dispatch(toggleFullscreen());
  }

  saveToNimbus() {
    this._shareCopyService.copy();
  }

  ngOnChanges() {
    this.isShowFullscreenButton = this.note.type === 'note';
    if (this.share && this.share.instance) {
      this.isB2B = isB2BOrgPredicate()(this.share.instance.org);
      this.setupPrintButton();
    }
    if (this.share && this.share.shareUrl && this.isBrowser) {
      const shareId = this.share.instance.id;
      const securityKey = this.share.instance.securityKey;
      this.shareUrl = `${window.location.origin}/share/${shareId}/${securityKey}`;
    }
    if (this.share && this.share.instance && this.share.instance.currentUserCanEdit
        && !this.visual.isEmbed && !this.visual.isMobile && this.visual.isFullWidth
        && this.note && this.profile) {
        const isSuitableRole = this.note.role == 'screencast' || this.note.role == 'video' || this.note.role == 'streaming_video' || this.note.role == 'screenshot' || this.note.role == 'clip';
        this.showShareConfigBtn = this.share.instance.currentUserCanEdit && isSuitableRole;
    } else {
      this.showShareConfigBtn = false;
    }
  }

  getSaveState() {
    return this.shareCopy.shareCopyStatus;
  }

  @HostListener('document:keydown.esc', ['$event'])
  closeFullScreen() {
    this._store.dispatch(turnOffFullscreen());
  }

  openConfigDialog() {
    const dialogOptions = {
      component: ShareConfigPopupComponent,
      hideCancelButton: true,
      okButtonText: 'Done',
      onSuccess: () => {
        this._store.dispatch(closeDialog());
      }
    }
    this._store.dispatch(openDialog(dialogOptions));
  }

  openPrintDialog() {
    const isFolder = this.note ? this.note.type == 'folder' : false;
    this._socialService.openPrintDialog(isFolder);
  }

  openSignUpDialog() {
    this._getNimbusPopupService.open();
  }

  private setupPrintButton() {
    const guestButton = {
      title: 'Sign up to Print',
      icon: 'print-def',
      handler: this.openSignUpDialog.bind(this),
    };
    const realButton = {
      title: 'Print',
      icon: 'print-def',
      handler: this.openPrintDialog.bind(this),
    };
    const { isEmbed, isEmbedPrintEnabled } = this.visual;
    const { sharesAllowPrint } = this.branding;
    const isB2B = this.isB2B;
    const isCustomer = !!this.profile;

    this.printButton = null;

    if (isEmbed) {
      if (isEmbedPrintEnabled) {
        this.printButton = realButton
      }
    } else if (isB2B) {
      if (sharesAllowPrint) {
        this.printButton = realButton
      }
    } else if (isCustomer) {
      this.printButton = realButton
    } else {
      this.printButton = guestButton
    }
  }

}
